<template>
    <v-dialog
        v-model="show"
        :max-width="options.width"
        persistent
        scrollable
        :style="{ zIndex: options.zIndex }"
        @keydown.esc="cancel"
    >
        <v-card>
            <v-toolbar flat>
                <v-row class="mt-3" dense align="center">
                    <v-col cols="auto">
                        <v-btn v-if="step > 1" icon @click="step -= 1">
                            <v-icon v-text="'$arrowLeft'" />
                        </v-btn>
                        <v-btn v-else icon>
                            <v-icon v-text="''" />
                        </v-btn>
                    </v-col>
                    <v-spacer />
                    <v-col cols="auto">
                        <v-toolbar-title>
                            {{ title }}
                        </v-toolbar-title>
                    </v-col>
                    <v-spacer />
                    <v-col cols="auto">
                        <v-btn icon @click.native="cancel">
                            <v-icon v-text="'$close'" />
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-row dense>
                            <v-spacer />
                            <v-col cols="auto">
                                {{ step }} шаг из {{ steps }}
                            </v-col>
                            <v-spacer />
                        </v-row>
                    </v-col>
                </v-row>
            </v-toolbar>

            <v-card-text>
                <v-sheet :min-height="minHeight">
                    <v-card-text>
                        <v-form ref="form" v-model="isFormValid" :disabled="readonly">
                            <v-row dense>
                                <v-col
                                    v-for="page in range(1, steps)"
                                    :key="page"
                                    cols="12"
                                >
                                    <slot v-if="page === step" :name="`step-${page}`" />
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-sheet>
            </v-card-text>

            <v-card-actions class="pt-0">
                <v-spacer />
                <v-btn
                    v-if="step < steps"
                    color="primary"
                    :disabled="!isFormValid"
                    text
                    @click="step += 1"
                >
                    {{ nextButtonText }}
                </v-btn>
                <v-btn
                    v-else
                    color="primary"
                    :disabled="!isFormValid"
                    text
                    @click.native="agree"
                >
                    {{ finishButtonText }}
                </v-btn>
                <v-spacer />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'UIStepDialog',

        props: {
            finishButtonText: { type: String, default: 'Завершить' },
            minHeight: { type: Number, default: 500 },
            nextButtonText: { type: String, default: 'Следующий шаг' },
            options: {
                type: Object,
                default: () => ({
                    width: 500,
                    zIndex: 200,
                    color: 'primary',
                }),
            },
            readonly: { type: Boolean, default: false },
            title: { type: String, default: 'Диалог' },
            steps: { type: Number, default: 1 },
        },

        data: () => ({
            dialog: false,
            isFormValid: false,
            resolve: null,
            reject: null,
            step: 1,
        }),

        computed: {
            show: {
                get() {
                    return this.dialog
                },
                set(value) {
                    this.dialog = value
                    if (value === false) {
                        this.cancel()
                    }
                },
            },
        },

        methods: {
            open() {
                this.dialog = true
                return new Promise((resolve, reject) => {
                    this.resolve = resolve
                    this.reject = reject
                })
            },

            agree() {
                this.resolve(true)
                this.dialog = false
                this.clear()
            },

            cancel() {
                this.resolve(false)
                this.dialog = false
                this.clear()
            },

            range(start, end) {
                return Array(end - start + 1).fill().map((_, idx) => start + idx)
            },

            clear() {
                this.step = 1
            },

            clearForm() {
                this.$refs?.form?.reset()
            },
        },
    }
</script>
